import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

class QuantitySelectorComponent extends Component {
  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement) || this.refs.quantityInput.disabled) return;

    event.preventDefault();
    this.refs.quantityInput.stepUp();
    this.#onQuantityChange();
  }

  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement) || this.refs.quantityInput.disabled) return;

    event.preventDefault();
    this.refs.quantityInput.stepDown();
    this.#onQuantityChange();
  }

  selectInputValue(event) {
    const { quantityInput } = this.refs;
    if (!(event.target instanceof HTMLInputElement) || document.activeElement !== quantityInput) return;

    quantityInput.select();
  }

  setQuantity(event) {
    if (!(event.target instanceof HTMLElement) || this.refs.quantityInput.disabled) return;

    event.preventDefault();
    if (event.target instanceof HTMLInputElement) {
      this.refs.quantityInput.value = event.target.value;
    }
    this.#onQuantityChange();
  }

  #onQuantityChange() {
    const { quantityInput } = this.refs;

    this.#checkQuantityRules();
    const newValue = parseInt(quantityInput.value);

    quantityInput.dispatchEvent(new QuantitySelectorUpdateEvent(newValue, Number(quantityInput.dataset.cartLine)));
  }

  #checkQuantityRules = () => {
    const { quantityInput } = this.refs;
    const minValue = Number(quantityInput.min);
    const maxValue = Number(quantityInput.max);
    const stepValue = Number(quantityInput.step);
    const minimum = quantityInput.min !== '' && Number.isFinite(minValue) ? minValue : 1;
    const maximum = quantityInput.max !== '' && Number.isFinite(maxValue) ? maxValue : Infinity;
    const step = Number.isSafeInteger(stepValue) && stepValue > 0 ? stepValue : 1;
    const fallback = Number(quantityInput.defaultValue);
    let value = quantityInput.valueAsNumber;
    if (!Number.isFinite(value)) value = Number.isFinite(fallback) ? fallback : minimum;
    value = minimum + Math.round((Math.max(minimum, value) - minimum) / step) * step;
    if (value > maximum) value = minimum + Math.floor((maximum - minimum) / step) * step;
    quantityInput.value = String(Math.max(minimum, value));
  };

  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error('Missing <input ref="quantityInput" /> inside <quantity-selector-component />');
    }

    return this.refs.quantityInput;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}
